$shm_hitalama_dragtree $mol_view
	layout* null
	indent 24
	item_height_default 40
	item_height* <= item_height_default
	item_height_px* \40px
	drop_item_offset_default 16
	drag_hold_delay 0
	drag_hold_move_threshold 10
	drag_touch_action \none
	roots? /
	children*? /
	can_have_children* true
	can_be_child* true
	drop_root_gutter false
	drop_folder_edges false
	drag_buttons* /number
		0
	expanded*? true
	drop_active? false
	drop_top? 0
	drop_left? 0
	drop_height? 0
	drop_parent? null
	drop_index? 0
	drag_x? 0
	drag_y? 0
	items /
		<= Drag*0 $shm_hitalama_dragtree_item
			buttons <= drag_buttons*
			style *
				^
				height \auto
				minHeight <= item_height_px* \40px
				touchAction <= drag_touch_action
			hold_delay <= drag_hold_delay
			hold_move_threshold <= drag_hold_move_threshold
			on_drag_start? <=> on_drag_start*? null
			on_drag_end? <=> on_drag_end*? null
			event *
				^
				dragstart? <=> native_drag_start*? null
				pointercancel? <=> on_drag_cancel*? null
			dragged => dragged*
			top? <=> y*? 0
			left? <=> x*? 0
			sub /
				<= Row* $mol_view
					sub /
						<= Guides* $mol_view
							sub <= guide_views* /
								<= Guide* $mol_view
									attr *
										^
										guide_orientation <= guide_orientation* \vertical
									style *
										left <= guide_left_px* \0px
										top <= guide_top_px* \0px
										bottom <= guide_bottom_px* \0px
										width <= guide_width_px* \1px
										height <= guide_height_px* \auto
						<= Toggle* $shm_hitalama_dragtree_toggle
							style *
								^
								display <= toggle_display* \none
							expanded? <=> toggle_expanded*? false
							pointerdown? <=> toggle_pointerdown*? null
						<= Content* $mol_view
							sub /
								<= Item* $mol_view
									sub /
										<= id* \
	sub /
		<= New_pos $mol_view
			style *
				display <= drop_display \none
				top <= drop_top_px \0px
				left <= drop_left_px \0px
				height <= drop_height_px \0px
			sub /
				<= Drop_guides $mol_view
					sub <= drop_guide_views /
						<= Guide* $mol_view
							attr *
								^
								guide_orientation <= guide_orientation* \vertical
							style *
								left <= guide_left_px* \0px
								top <= guide_top_px* \0px
								bottom <= guide_bottom_px* \0px
								width <= guide_width_px* \1px
								height <= guide_height_px* \auto
		<= Panel $mol_view
			style * height <= full_height_px \
			sub /
				^ items
